<template>
  <path 
    fill-rule="evenodd" 
    clip-rule="evenodd" 
    d="M1.40895 11.6804C1.84411 9.91324 2.26426 8.15728 2.74969 6.4009C3.16176 4.91362 4.70587 4.04218
     6.19315 4.45425C7.68043 4.86632 8.55145 6.40774 8.13938 7.89502C7.66748 9.60063 7.26082 11.3058 
     6.83643 13.0226C6.46638 14.5222 4.94998 15.4369 3.45043 15.0668C1.95363 14.6963 1.0389 13.1799 
     1.40895 11.6804Z"
  />
  <path 
    fill-rule="evenodd" 
    clip-rule="evenodd" 
    d="M12.9874 20.7928C17.6608 17.5117 22.4966 14.468 27.2367 11.2884C28.5185 10.4276 30.2577 
    10.7714 31.1185 12.0531C31.9765 13.3354 31.6351 15.0712 30.3534 15.932C25.6465 19.0914 20.8429 
    22.1092 16.2028 25.3701C14.9397 26.2559 13.1933 25.9506 12.3075 24.6876C11.419 23.4251 11.7243 
    21.6786 12.9874 20.7928Z"
  />
  <path 
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M19.132 40.33C23.9373 40.2335 28.7556 40.271 33.5592 40.1179C35.0997 40.0713 36.3912 41.2834 
    36.4411 42.8261C36.4882 44.3693 35.276 45.6608 33.7333 45.7106C28.909 45.8589 24.0714 45.8249 
    19.2436 45.9227C17.7002 45.9528 16.4232 44.7267 16.3931 43.1833C16.3602 41.6404 17.5886 40.3601 
    19.132 40.33Z"
  />
</template>

<script>
export default {

}
</script>


<style scoped>
    path {
        font-family: var(--iconFontFamily);
        font-size: var(--iconFontSize);
        fill: var(--iconTextColor);
        stroke: var(--iconBorderColor);
    }
</style>